import { Component, OnInit, forwardRef, Input, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';
import { SabisTranslateService } from '../translation/sdp-translate.service';

/**
 *  Properties:
 *      scLabel: Label for the textArea
 *      scCols :  The horizontal size of a text area
 *      scRows : The vertical size of a text area
 *      scPlaceholder: text area  place holder
 * */
@Component({
  selector: 'sabis-ngx-textarea',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SabisTextArea2Component),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SabisTextArea2Component),
      multi: true,
    }
  ]

})
export class SabisTextArea2Component implements OnInit, ControlValueAccessor, Validator {
  @Input('scIsReadonly') scIsReadonly: boolean = false;
  @Input('scLabel') scLabel: string = '';
  @Input('scCols') scCols: number = 20;
  @Input('scRows') scRows: number = 5;
  @Input('scPlaceholder') scPlaceholder: string = '';
  @Input('scHideValidationMessage') scHideValidationMessage: boolean = false;
  @Input('scWidth') scWidth: string = '100%';

  public isDisabled: boolean = false;
  private onChangeCallback: null | ((v: string | number) => void) = null;
  private onTouchedCallback: null | ((e: any) => void) = null;


  constructor(private _translateService: SabisTranslateService) { }

  private _innerValue: string = '';
  isValid: boolean = true;
  validationMessage: string = '';

  get value() {
    return this._innerValue;
  }
  set value(v: any) {
    if (this._innerValue !== v) {
      this._innerValue = v;
    }
  }
  ngOnInit() {
  }

  /**
* Handler for model change 
* @param event
*/
  onModelChange(event: any) {
    if (this.onChangeCallback) {
      this.onChangeCallback(this._innerValue);
    }
  }

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;

  }
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;

  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onBlur(event: any) {
    if (this.onTouchedCallback) {
      this.onTouchedCallback(event);
    }
  }

  validate(c: AbstractControl): { [key: string]: any; } {
    this.setValidationMessage(c);
    return {};
  }
  registerOnValidatorChange?(fn: () => void): void {

  }
  private setValidationMessage(c: AbstractControl): void {
    //set Time out because the control changes validation after passing in the validate function
    setTimeout(() => {
      this.isValid = c.errors == null;
      if (!this.isValid) {
        for (var e in c.errors) {
          if (e == "required") {
            this.validationMessage = this._translateService.instant("SabisComponents.FieldRequired");
          }
          else if (e == "maxlength") {
            this.validationMessage = this._translateService.instant("SabisComponents.MaxLengthIs") + " " + c.errors['maxlength'].requiredLength;
          }
          else {
            this.validationMessage = "";
          }
        }
      }
    });
  }
}
